import { FunctionComponent } from 'react'

import config from '@config'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import EmbeddedContent, {
  EmbeddedContentWebProps,
} from '@components/EmbeddedContent'
import JSONRenderer from '@components/JSONRenderer'

const {
  financeScout: { allowedOrigins },
} = config

export interface EmbeddedContentWidgetProps extends EmbeddedContentWebProps {
  contentId: string
  title: string
}

const isFinanceScoutSpecialIframe = (url?: string) => {
  if (!url) {
    return false
  }
  const iframeOrigin = new URL(url).origin
  return allowedOrigins.some((origin) => origin === iframeOrigin)
}

const EmbeddedContentWidget: FunctionComponent<EmbeddedContentWidgetProps> = (
  props
) => {
  if (isFinanceScoutSpecialIframe(props.url)) {
    return (
      <JSONRenderer>
        {{ ...props, kind: ['widget', 'tool', 'finance-scout'] }}
      </JSONRenderer>
    )
  }
  return <EmbeddedContent {...props} trackImpression />
}

const widget = {
  kind: ['widget', 'embedded-content'],
  component: EmbeddedContentWidget,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
